import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Persistent, anonymous session id (survives reloads, resets rarely)
function getSessionId() {
  try {
    let sid = localStorage.getItem('nlt_sid');
    if (!sid) {
      sid = 'sid_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem('nlt_sid', sid);
    }
    return sid;
  } catch (e) {
    return 'sid_ephemeral';
  }
}

/**
 * Logs a pageview to our own analytics on every route change — for BOTH
 * anonymous visitors and logged-in users. Never blocks the UI.
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    if (path === lastPath.current) return;
    lastPath.current = path;

    const token = localStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        session_id: getSessionId(),
        path,
        referrer: document.referrer || '',
        event_type: 'pageview',
      }),
      keepalive: true,
    }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
